import React from 'react';

interface PaginatorProps {
  total: number;
  page: number;
  pageSize?: number;
  onPage: (p: number) => void;
}

const Paginator: React.FC<PaginatorProps> = ({ total, page, pageSize = 10, onPage }) => {
  const pages = Math.ceil(total / pageSize);
  if (pages <= 1) return null;

  const start = Math.max(1, page - 2);
  const end   = Math.min(pages, page + 2);
  const nums: number[] = [];
  for (let i = start; i <= end; i++) nums.push(i);

  const btn = (label: string | number, target: number, active = false, disabled = false) => (
    <button
      key={label}
      onClick={() => !disabled && onPage(target)}
      style={{
        padding: '6px 12px', borderRadius: 8, border: '1px solid #e2e8f0',
        background: active ? '#2563eb' : disabled ? '#f8fafc' : '#fff',
        color: active ? '#fff' : disabled ? '#cbd5e1' : '#475569',
        fontWeight: active ? 700 : 500, fontSize: 13,
        cursor: disabled ? 'default' : 'pointer', transition: 'all .15s',
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center', justifyContent: 'flex-end', marginTop: 16 }}>
      <span style={{ fontSize: 12, color: '#94a3b8', marginRight: 8 }}>
        Page {page} of {pages} ({total} results)
      </span>
      {btn('«', 1, false, page === 1)}
      {btn('‹', page - 1, false, page === 1)}
      {start > 1 && <>{btn(1, 1)}{start > 2 && <span style={{ color: '#94a3b8' }}>…</span>}</>}
      {nums.map((n) => btn(n, n, n === page))}
      {end < pages && <>{end < pages - 1 && <span style={{ color: '#94a3b8' }}>…</span>}{btn(pages, pages)}</>}
      {btn('›', page + 1, false, page === pages)}
      {btn('»', pages, false, page === pages)}
    </div>
  );
};

export default Paginator;
